import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import AgConverge from './pages/AgConverge';
import StartupShowcases from './pages/StartupShowcases';
import FarmerTechChallenge from './pages/FarmerTechChallenge';
import IndustryAcademicPanel from './pages/IndustryAcademicPanel';
import Contact from './pages/Contact';
import Resources from './pages/Resources';
import NeAgTechMap from './pages/NeAgTechMap';
import WhyAgTechFails from './pages/WhyAgTechFails';
import HuskerHarvestDaysArticle from './pages/HuskerHarvestDaysArticle';
import AgConvergeNew from './pages/AgConvergeNew';
import NebraskaAgTechInnovationReport from './pages/NebraskaAgTechInnovationReport';
import './styles/App.css';

function App() {
  return (
    <Router>
      <div className="App">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/agconverge" element={<AgConvergeNew />} />
            <Route path="/startup-showcases" element={<StartupShowcases />} />
            <Route path="/farmer-tech-challenge" element={<FarmerTechChallenge />} />
            <Route path="/industry-academic-panel" element={<IndustryAcademicPanel />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/resources" element={<Resources />} />
            <Route path="/resources/nebraska-agtech-map-2026" element={<NeAgTechMap />} />
            <Route path="/resources/why-agtech-startups-fail" element={<WhyAgTechFails />} />
            <Route path="/resources/husker-harvest-days-2026" element={<HuskerHarvestDaysArticle />} />
            <Route path="/agconverge-old" element={<AgConverge />} />
            <Route
              path="/resources/nebraska-agtech-innovation-report"
              element={<NebraskaAgTechInnovationReport />}
            />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;